import { createI18n } from "vue-i18n";
import enMessage from "@/lang/en.json";

const messages = {
  en: enMessage,
};

const i18n = createI18n({
  legacy: false,
  locale: "en",
  globalInjection: true,
  messages,
});

export default i18n;
